import { styled } from '@mui/material/styles'
import { Grid } from '@mui/material'

export const GridContainer = styled(Grid)(`
    margin-top: -35px;
    padding: 0px 20px 15px;
    & > div {
        padding-top:0;
    }
`)
